<md-card *ngIf="clientData;"
         style="min-height: 100vh;">
  <div class=" row ">
    <div class="col-md-12 ">
      <button class="btn btn-primary"
              (click)="goBack() ">Go Back</button>
    </div>
    <ng-template #image></ng-template>

    <div class="col-md-12 text-center ">
      <h2 #actualTarget>Uploaded Files</h2>

    </div>
  </div>

  <div class="wrapper "
       style="margin-left: -25px; margin-right: -25px; ">
    <angular-filemanager></angular-filemanager>

  </div>

  <!-- <div class="row ">
      <div class="col-md-6 ">
        <h3 class="first ">Primary Icons</h3>
        <p-fileUpload name="demo[] " (onUpload)="onUpload($event) " (uploadHandler)="imageUploader($event, 'icon-primary') " customUpload="true " multiple="multiple " accept="image/* " maxFileSize="1000000 ">
          <ng-template pTemplate="content ">
            <ul *ngIf="uploadedFiles.length ">
              <li *ngFor="let file of uploadedFiles ">{{file.name}} - {{file.size}} bytes</li>
            </ul>
          </ng-template>
        </p-fileUpload>
      </div>

      <div class="col-md-6 ">
        <h3 class="first ">Files</h3>
        <p-dataGrid [value]="cars " [paginator]="true " [rows]="10 ">
          <ng-template let-car pTemplate="item ">
            <div style="padding:3px " class="ui-g-12 ui-md-3 ">
              <p-panel [header]="car.vin " [style]="{ 'text-align': 'center'} ">
                <img src="assets/showcase/images/demo/car/ {{car.brand}} .png " width="60 ">
                <div class="car-detail ">{{car.year}} - {{car.color}}</div>
                <hr class="ui-widget-content " style="border-top:0 ">
              </p-panel>
            </div>
          </ng-template>
        </p-dataGrid>
      </div>
    </div> -->

  <!---->
  <!---->
  <!---->
  <!-- <div class="row ">
      <div class="col-md-12 margin-top ">
        <p-menubar [model]="items " [autoDisplay]="false ">


        </p-menubar>


        <p-tree [value]="aws.files ">
          <ng-template let-node pTemplate="default ">
            <div style="display: flex; padding-bottom: 5px; ">

              <button *ngIf="!node.data.isFolder " icon="fa fa-fw fa-file-image-o " pButton type="button " class="ui-button-secondary " (mouseenter)="op1.show($event, actualTarget) " (mouseleave)="op1.hide() "></button>
              <p class='version-numbah' *ngIf="!node.data.isFolder ">{{node.label}}</p>
              <h4 class='version-numbah-bold' *ngIf="node.data.isFolder ">{{node.label}}</h4>

              <!-- <p-inplace *ngIf="!node.data.isFolder " closable="closable ">
                <span pInplaceDisplay>
                  <button icon="fa fa-fw fa-file-image-o " pButton type="button " class="ui-button-secondary "></button>
                </span>
                <span pInplaceContent>
                  <img src=" {{node.data.url}} " style="max-width: 250px; "  alt="Galleria 1 " />
                </span>
              </p-inplace> -->
  <!-- <button icon="fa fa-fw fa-file-image-o " pButton type="button " class="ui-button-secondary "></button> -->
  <!-- </div>

            <p-overlayPanel #op1 [dismissable]="true " [showCloseIcon]="true ">
              <img src=" {{node.data.url}} " style="max-width: 500px; " alt="Galleria 1 " />

            </p-overlayPanel>
          </ng-template>


        </p-tree>
      </div>
    </div> -->

</md-card>



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/component-file-upload/component-file-upload.component.html